import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tooltip,
} from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import Table, { buttonsStyle } from "../tables/table";

function getData(categories) {
	let data = [];
	for (let i = 0; i < categories.length; ++i) {
		const elem = {};
		const category = categories[i];

		elem.descripcion = category?.descripcion;
		elem.referencia = category?.referencia;
		elem.id = category?.id;

		data = data.concat(elem);
	}
	return data;
}

const PartidaCategoryTableDialog = (props) => {
	const { title, open, setOpen, data, onSelect } = props;

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		return (
			<>
				<Tooltip title="Seleccionar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							onSelect(cell);
							setOpen(false);
						}}
					>
						<AddCircle />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "descripcion", text: "Descripción", sort: true },
		{
			dataField: "referencia",
			text: "Referencia",
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	return (
		<>
			<Dialog
				fullWidth={true}
				maxWidth="md"
				open={open}
				onClose={() => {
					setOpen(false);
				}}
				aria-labelledby="table-dialog"
				className="backdrop"
			>
				<DialogTitle id="table-dialog">
					{"Categorías de partidas"}
				</DialogTitle>
				<DialogContent>
					{!data || !data.length ? (
						<p>{"No hay categorías de partidas disponibles."}</p>
					) : (
						<Table data={getData(data)} columns={columns} />
					)}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => {
							setOpen(false);
						}}
						variant="outlined"
					>
						Cancelar
					</Button>
					<br />
				</DialogActions>
			</Dialog>
		</>
	);
};
export default PartidaCategoryTableDialog;
